import { render } from "./Inbox2.vue?vue&type=template&id=071ea758"
import script from "./Inbox2.vue?vue&type=script&lang=js"
export * from "./Inbox2.vue?vue&type=script&lang=js"

import "./Inbox2.vue?vue&type=style&index=0&id=071ea758&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__